import React, { Component } from "react";


export default class uploadIcon extends Component {
  render() {
    return (
      <svg
        className={this.props.className}
        onClick={this.props.onClick}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 12L17.5 15.3333C17.5 15.7754 17.3244 16.1993 17.0118 16.5118C16.6993 16.8244 16.2754 17 15.8333 17L4.16667 17C3.72464 17 3.30072 16.8244 2.98816 16.5118C2.67559 16.1993 2.5 15.7754 2.5 15.3333L2.5 12"
          stroke="white"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5767 7.24609L9.99929 3.66868L6.42188 7.24609"
          stroke="white"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 3.83398L10 13.834"
          stroke="white"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}
